<template>
    <div class="form__field password-input">
        <label class="input__label">
            <div>{{ $t(label) | capitalize }}</div>
            <button
                type="button"
                class="btn visibility-toggle"
                v-if="showPasswordVisibilitySwitch"
                @click="togglePasswordVisibility"
            >
                <i :class="visibilityIconClass" />
                {{ $t(showHidePassword) | capitalize }}
            </button>
            <slot name="label-sibling" />
        </label>
        <input
            :class="{ 'input__field--error' : errorMessage }"
            class="input__field"
            :type="isPasswordHidden ? 'password' : 'text'"
            :value="value"
            :autocomplete="shouldAutoFill ? '' : 'new-password'"
            v-bind="$attrs"
            @input="onInputOwn"
            @blur="onBlur"
            ref="input"
        >
        <span
            v-if="showStrengthMeter && passwordStrength"
            class="small_font"
        >
            {{ $t('password strength') | capitalize }}: {{ $t(passwordStrength) | capitalize }}
        </span>

        <div
            v-if="errorMessage"
            class="message message--error"
        >
            <i class="icon icon--xs icon-warning_triangle"/>
            {{ errorMessage }}
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { evaluatePasswordStrength } from '@app/utils/passwordStrength';
    import BaseInput from './forms/BaseInput';

    const scoreMap = {
        0: 'weak',
        1: 'weak',
        2: 'good',
        3: 'strong',
        4: 'very strong',
    };

    export default Vue.component('Password', {
        name: 'Password',
        mixins: [BaseInput],
        props: {
            label: {
                type: String,
                required: false,
                default: 'password'
            },
            errorMessage: {
                type: String,
                required: false
            },
            showStrengthMeter: {
                type: Boolean,
                required: false,
                default: true
            },
            showPasswordVisibilitySwitch: {
                type: Boolean,
                default: true,
            },
            shouldAutoFill: {
                type: Boolean,
                required: false,
                default: true,
            },
        },
        data() {
            return {
                isPasswordHidden: true,
                passwordStrength: null,
            };
        },
        computed: {
            showHidePassword() {
                return this.isPasswordHidden ? 'show password' : 'hide password';
            },
            visibilityIconClass() {
                return [
                    'icon',
                    this.isPasswordHidden ? 'icon-eye' : 'icon-eye_crossed_out'
                ];
            }
        },
        methods: {
            onInputOwn(e) {
                this.onInput(e);
                this.passwordStrength = this.getScore(e.target.value);
            },
            getScore(value) {
                const score = evaluatePasswordStrength(value);
                return scoreMap[score];
            },
            togglePasswordVisibility() {
                this.isPasswordHidden = !this.isPasswordHidden;
                this.focusInput();
            },
            focusInput() {
                this.$refs.input.focus();
            },
        },
    });
            /* eslint-enable */
</script>

<style scoped>
    .small_font {
        font-size: 12px;
    }
</style>


// WEBPACK FOOTER //
// src/app/modules/shared/components/Password.vue